import { tokenAliasOrValue } from "./base";
import { z } from "zod";
export const StringValue = z.string();
export const StringTokenData = tokenAliasOrValue(StringValue);
